export const GET_ROUNDS_ATTEMPT = 'GET_ROUNDS_ATTEMPT';
export const GET_ROUNDS_SUCCESS = 'GET_ROUNDS_SUCCESS';
export const GET_ROUNDS_FAILURE = 'GET_ROUNDS_FAILURE';
export const SUBMIT_ATTEMPT = 'SUBMIT_ATTEMPT';
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const SUBMIT_FAILURE = 'SUBMIT_FAILURE';
export const CLEAR_UPLOADER_STATE = 'CLEAR_UPLOADER_STATE';
export const CLEAR_STATE = 'CLEAR_STATE';
